const translations = {
  ' que digitaliza y automatiza tu operación de principio a fin.': ' that digitizes and automates your operation end to end.',
  '404 - Página no encontrada': '404 - Page not found',
  'Administración': 'Administration',
  'Administración de cartera': 'Portfolio management',
  'Aprobación de crédito': 'Credit approval',
  'Aprobación de Créditos': 'Credit approvals',
  'Automatiza procesos financieros': 'Automate financial processes',
  'Automatización de créditos': 'Credit automation',
  'Candado de Smartphone': 'Smartphone Lock',
  'CNBV': 'CNBV',
  'Condusef': 'Condusef',
  'Core bancario y plataforma Fintech': 'Banking core and Fintech platform',
  'Core Financiero': 'Financial Core',
  'Creamos tecnología para liderar la transformación financiera': 'We build technology to lead financial transformation',
  'Cumple con normativas CNBV y refuerza la seguridad con nuestro módulo avanzado de prevención de lavado de dinero.': 'Comply with CNBV regulations and strengthen security with our advanced anti-money laundering module.',
  'Desde la originación hasta la cobranza, te acompañamos en cada etapa con módulos diseñados para que tu operación sea ágil, precisa y totalmente segura.': 'From origination to collections, we support every stage with modules designed to keep your operation agile, accurate, and fully secure.',
  'Digitalización de créditos': 'Credit digitization',
  'Digitalización de procesos': 'Process digitization',
  'Digitalización financiera': 'Financial digitization',
  'Dispersión de crédito': 'Credit disbursement',
  'Emisión de tarjeta': 'Card issuance',
  'Finanzas': 'Finance',
  'Gestión de cobranza': 'Collections management',
  'Gracias por proporcionarnos sus datos': 'Thank you for providing your information',
  'Innovación financiera': 'Financial innovation',
  'La transformación de tu empresa comienza con la tecnología adecuada: una ': 'Your company transformation starts with the right technology: a ',
  'La transformación de tu empresa comienza con la tecnología adecuada: una plataforma modular que digitaliza y automatiza tu operación de principio a fin.': 'Your company transformation starts with the right technology: a modular platform that digitizes and automates your operation end to end.',
  'Mensajes automatizados': 'Automated messages',
  'Nuestro Core Bancario está diseñado para impulsar a entidades financieras y empresas que buscan eficiencia operativa e innovación.': 'Our Banking Core is designed to empower financial institutions and companies seeking operational efficiency and innovation.',
  'Página no encontrada, regresa al inicio': 'Page not found, go back to home',
  'Plataforma financiera': 'Financial platform',
  'Plataforma para gestión de créditos': 'Credit management platform',
  'Prevención de Lavado de Dinero (PLD)': 'Anti-Money Laundering (AML)',
  'Principales módulos que transforman tu operación': 'Core modules that transform your operation',
  'Procesos digitales': 'Digital processes',
  'Producto financiero': 'Financial product',
  'Sector financiero': 'Financial sector',
  'Servicios financieros': 'Financial services',
  'Sitemap': 'Sitemap',
  'Software financiero': 'Financial software',
  'Software para Créditos': 'Credit software',
  'Soluciones Digitales para Entidades Financieras': 'Digital Solutions for Financial Institutions',
  'Tecnología financiera': 'Financial technology',
  'Toma decisiones financieras acertadas con nuestro análisis de crédito y score alternativo. Reduce riesgos y mejora la calidad crediticia.': 'Make better financial decisions with our credit analysis and alternative scoring. Reduce risk and improve credit quality.',
  'Transacciones': 'Transactions',
  'Transforma tu empresa con un core bancario modular que digitaliza y automatiza tu operación de principio a fin. Tecnología avanzada para instituciones financieras.': 'Transform your company with a modular banking core that digitizes and automates your operation end to end. Advanced technology for financial institutions.',
  'Transformación digital': 'Digital transformation',
  'Un Core Bancario que va más allá': 'A Banking Core that goes further',
  'Webinar DynamiCore': 'DynamiCore Webinar',
  'Work flows': 'Workflows',
  'Contáctanos': 'Contact Us',
  'Todos los derechos reservados': 'All rights reserved',
  'Análisis Crediticio': 'Credit Analysis',
  'Dispersión': 'Disbursement',
  'Emisión de tarjetas': 'Card Issuance',
  'Campaña de notificaciones': 'Notification Campaign',
};

export default translations;
